import { FC, useState } from 'react';

import { Col, Row } from 'antd';
import { Dropdown, Icon } from 'ui';

import { ExtraFieldGrouping } from 'services/events/evetns.api.type';

import s from '../ExtraFields.module.scss';

interface ExtraFieldGroupingItemProps {
  handleDeleteItem: (id: string) => void;
  setEditGrouping: (notification: ExtraFieldGrouping) => void;
  grouping: ExtraFieldGrouping;
  id: string;
}

const DROPDOWN_ITEMS = [
  { key: 'edit', label: <div className={s.dropdownItem}>Edit</div> },
  { key: 'delete', label: <div className={s.dropdownItem}>Delete</div> },
];

const ExtraFieldGroupingItem: FC<ExtraFieldGroupingItemProps> = ({
  handleDeleteItem,
  id,
  grouping,
  setEditGrouping,
}) => {
  const [openedDropdown, setOpenedDropdown] = useState(false);

  const handleClickDropdownItems = (event: { key: string }, id: string) => {
    if (event.key === 'delete') {
      setOpenedDropdown(false);
      handleDeleteItem(id);
    }

    if (event.key === 'edit') {
      setOpenedDropdown(false);
      setEditGrouping(grouping);
    }
  };
  return (
    <Row
      gutter={[0, 8]}
      style={{
        minWidth: 600,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: 16,
      }}>
      <Col span={5}>{grouping?.name}</Col>
      <Col span={5}>{grouping?.showTitle ? 'True' : 'False'}</Col>
      <Col span={5}>{grouping?.sortOrder}</Col>
      <Col span={5}>{grouping?.captureType === 'ByOrder' ? 'By Order' : 'By Ticket'}</Col>
      <Col span={4}>
        <Dropdown
          items={DROPDOWN_ITEMS}
          placement="bottomRight"
          handleItemClick={(event) => handleClickDropdownItems(event, id as string)}
          open={openedDropdown}
          onOpenChange={setOpenedDropdown}>
          <div className={s.dropdownButton}>
            <Icon name="verticalDots" color="#7d7da2" />
          </div>
        </Dropdown>
      </Col>
    </Row>
  );
};

export default ExtraFieldGroupingItem;
